import { useEffect } from "react";
import { PropsWithChildren, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./shadcn/tooltip";

export function TruncatedTextWithTooltip({ children }: PropsWithChildren) {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      // Compare the scroll width with the available offset width.
      setIsTruncated(textRef.current.scrollWidth > textRef.current.offsetWidth);
    }
  }, [children]);

  if (!isTruncated) {
    return (
      <div ref={textRef} className="truncate">
        {children}
      </div>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div ref={textRef} className="truncate">
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent>{children}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
